import { MockedRequest, RequestHandler, rest, restContext } from 'msw';
import categories from '../fixtures/Category';

const handlers: RequestHandler<MockedRequest, typeof restContext>[] = [
  rest.get('/api/resource/categories', (req, res, ctx) => {
    return res(ctx.json(categories));

    // uncomment to test error code 401 mock case
    // return res(ctx.status(401), ctx.json({ message: 'Access token is missing or invalid' }));
  }),
];

export default handlers;
